import { PaymentsLanding, type PaymentsLandingTabs } from "components/PaymentsLanding/PaymentsLanding";
import { createFileRoute } from "@tanstack/react-router";

interface TabSearchParams {
    agingIndex: number | null;
}

export const historyRoutePath = "/history/$tab";

export const Route = createFileRoute(historyRoutePath)({
    component: PaymentsLanding,
    params: {
        parse: (params): { tab: PaymentsLandingTabs | undefined } => {
            // if the tab is valid, return it, otherwise return undefined
            if (["bulk-request", "patients", "payments"].includes(params.tab)) {
                return { tab: params.tab as PaymentsLandingTabs };
            }

            return { tab: undefined };
        },
    },
    validateSearch: (search): TabSearchParams => {
        // validate and parse the search params into a typed state
        return {
            agingIndex: typeof search.agingIndex === "number" ? search.agingIndex : null,
        };
    },
});
